import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { CloudImage } from "~/types/CloudImage";
import { setAsset } from "./assetSlice";
import { getAiDetectionsThunk } from "~/thunks/annotationsThunks";
import type { Annotation } from "~/types/annotations";
import type { RootState } from "~/store";

interface ImagesModuleState {  
  images: CloudImage[];
  selectedImages: CloudImage[];
  selectedImage?: CloudImage;
  selectedImagePaths: string[]
  loading: boolean;
  reversed: boolean;
}

const initialState: ImagesModuleState = {
  images: [],
  selectedImage: undefined,
  selectedImages: [],
  selectedImagePaths: [],
  loading: false,
  reversed: false,
};


const imagesModuleSlice = createSlice({
  name: "imagesModule",
  initialState,
  reducers: {
    setImages: (state, action: PayloadAction<CloudImage[]>) => {
      // console.log("setImages", action.payload);
      const uniqueImages = new Set();
      action.payload.forEach((image) => {
        if (image && image.fullImageName) {
          uniqueImages.add(image);
        } else {
          console.warn("Image without fullImageName", image);
        }
      });
      // console.log("uniqueImages", uniqueImages);
      state.images = Array.from(uniqueImages) as CloudImage[];
    },
    addImage: (state, action: PayloadAction<CloudImage>) => {
      state.images.push(action.payload);
    },
    removeImage: (state, action: PayloadAction<string>) => {
      state.images = state.images.filter((image) => image.fullImageName !== action.payload);
    },
    setSelectedImage: (state, action: PayloadAction<CloudImage | undefined>) => {
      state.selectedImage = action.payload;
    },
    setSelectedImagePaths: (state, action: PayloadAction<string[]>) => {
      state.selectedImagePaths = action.payload;
    },
    setSelectedImages: (state, action: PayloadAction<CloudImage[]>) => {
      state.selectedImages = action.payload;
    },
    toggleReversed: (state) => {
      state.reversed = !state.reversed;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAiDetectionsThunk.pending, (state, action) => {
        state.loading = true;
      }).
      addCase(getAiDetectionsThunk.fulfilled, (state, action: PayloadAction<Annotation[]>) => {
        state.loading = false;
        const imagesWithDetections: CloudImage[] = state.images.map((image: CloudImage) => {
          const detections = action.payload.filter((detection: any) => detection.imageLink === image.fullImageLink);
          return {
            ...image,
            aiDetections: detections as any,
          };
        });
                
        state.images = imagesWithDetections;
      })
      .addCase(setAsset, (state, action: PayloadAction<any>) => {
        state.images = [];
        state.selectedImage = undefined;
        state.loading = false;
      })
      
  },
});

export default imagesModuleSlice.reducer;
export const { setSelectedImage, setImages, addImage, removeImage,
   setSelectedImagePaths, setSelectedImages, toggleReversed } = imagesModuleSlice.actions;
export const selectImages = (state: RootState) => state.imagesModule.images;
export const selectSelectedImage = (state: RootState) => state.imagesModule.selectedImage;
export const selectImagesLoading = (state: RootState) => state.imagesModule.loading;
export const selectSelectedImagePaths = (state: RootState) => state.imagesModule.selectedImagePaths;
export const selectSelectedImages = (state: RootState) => state.imagesModule.selectedImages;
export const selectReversed = (state: RootState) => state.imagesModule.reversed;